import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["columnConfig", "rowData", "rowIndex", "onAction", "className", "cellStyle"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import cx from 'classnames';
import _noop from 'lodash/noop';
import _castArray from 'lodash/castArray';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import ACTION_TYPES from '../../../FormBuilder/constants/actionTypes';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';

// Helpers
import { getCellConfigToRender, getCellValue, getUpdatedRowData, getCellOnChangeValue, getComponentProps } from './inputTableCell.helpers';
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();
var InputTableCell = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputTableCell, _PureComponent);
  var _super = _createSuper(InputTableCell);
  function InputTableCell() {
    var _this;
    _classCallCheck(this, InputTableCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getCellConfigToRender", defaultMemoize(getCellConfigToRender));
    _defineProperty(_assertThisInitialized(_this), "getComponentProps", defaultMemoize(getComponentProps));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var _this$props = _this.props,
        onAction = _this$props.onAction,
        columnConfig = _this$props.columnConfig,
        rowData = _this$props.rowData,
        rowIndex = _this$props.rowIndex;
      for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }
      var updatedValue = getUpdatedRowData({
        inputParams: params,
        columnConfig: columnConfig,
        rowData: rowData,
        props: _this.props
      });
      var value = getCellOnChangeValue(params, columnConfig, _this.props);
      var columnId = columnConfig.getColumnId();
      return onAction({
        type: ACTION_TYPES.ON_FIELD_CHANGE,
        payload: {
          value: value,
          id: columnId,
          nestingPath: _castArray(rowIndex),
          params: params,
          additional: {
            updatedValue: updatedValue,
            pathToUpdate: rowIndex
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var _this$props2 = _this.props,
        onAction = _this$props2.onAction,
        columnConfig = _this$props2.columnConfig,
        rowIndex = _this$props2.rowIndex;
      var columnId = columnConfig.getColumnId();
      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }
      return onAction({
        type: ACTION_TYPES.ON_FIELD_BLUR,
        payload: {
          id: columnId,
          nestingPath: _castArray(rowIndex),
          params: params
        }
      });
    });
    return _this;
  }
  _createClass(InputTableCell, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        columnConfig = _this$props3.columnConfig,
        rowData = _this$props3.rowData,
        rowIndex = _this$props3.rowIndex,
        onAction = _this$props3.onAction,
        className = _this$props3.className,
        cellStyle = _this$props3.cellStyle,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var cellConfig = this.getCellConfigToRender(this.props);
      var Component = cellConfig.getComponent();
      var componentProps = this.getComponentProps(cellConfig, this.props);
      var cellValue = getCellValue({
        columnConfig: columnConfig,
        rowData: rowData,
        rowIndex: rowIndex
      });
      var cellWidth = columnConfig.getWidth();
      var cellMinWidth = columnConfig.getMinWidth();
      var cellClassName = columnConfig.getCellClassName();
      var inputTableCellStyle = {
        width: cellWidth,
        minWidth: cellMinWidth
      };
      return /*#__PURE__*/React.createElement("div", {
        className: cx(className, cellClassName),
        style: _objectSpread(_objectSpread({}, inputTableCellStyle), cellStyle)
      }, /*#__PURE__*/React.createElement(Component, _extends({
        onBlur: this.handleBlur
      }, rest, {
        value: cellValue
      }, componentProps, {
        columnConfig: columnConfig,
        rowData: rowData,
        rowIndex: rowIndex,
        onChange: this.handleChange,
        onAction: onAction
      })));
    }
  }]);
  return InputTableCell;
}(PureComponent);
InputTableCell.propTypes = {
  rowData: PropTypes.object,
  columnConfig: PropTypes.object,
  rowIndex: PropTypes.number,
  onAction: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.string,
  cellStyle: PropTypes.object
};
InputTableCell.defaultProps = {
  rowData: EMPTY_OBJECT,
  columnConfig: DEFAULT_COLUMN_CONFIG,
  rowIndex: 0,
  onAction: _noop,
  className: '',
  error: undefined,
  cellStyle: EMPTY_OBJECT
};
export default InputTableCell;